__webpack_require__.p = "/blog_client/";